import { t } from 'i18next'

import Loading from '~/components/Loading'
import { FormGroup } from '~/components/unform/FormGroup'

import Button from '../Button'

const ButtonsCancelSave = ({
  onCancelClick,
  onSaveClick,
  isLoading = false,
  isDisabled = false,
  isSaveLoading = false,
  showSavingChangesLoading = false,
  saveButtonLabel = t('rm:button.Save'),
  styleOnTop = 'margin',
  submitButtonType = 'submit'
}: ButtonsCancelSaveProps) => {
  const showButtons = !showSavingChangesLoading || !isLoading
  const wrapperClass =
    styleOnTop === 'line' ? 'form-default__buttons' : 'actionButtons'

  return (
    <FormGroup className={`${wrapperClass} form-default__buttons-pb0`}>
      {showSavingChangesLoading && (
        <Loading status={isLoading}>{t('rm:savingChanges')}</Loading>
      )}

      {showButtons && (
        <>
          <Button
            template="transparentCritical"
            onClick={onCancelClick}
            text={t('rm:button.Cancel')}
            loading={isLoading}
          />

          <Button
            type={submitButtonType}
            template="primary"
            loading={isLoading || isSaveLoading}
            disabled={isDisabled || isLoading || isSaveLoading}
            text={saveButtonLabel}
            textLoading={isLoading ? t('rm:saving') : undefined}
            {...(onSaveClick && { onClick: onSaveClick })}
          />
        </>
      )}
    </FormGroup>
  )
}

export default ButtonsCancelSave
